import '../layout/theme';
import { DefaultLayout, drawDefaultLayout } from './components/layout/DefaultLayout';
import { createRoot } from 'react-dom/client';
import React from 'react';
import { CheckoutSurveyPage } from './components/checkout/CheckoutSurveyPage/CheckoutSurveyPage';
import { BaseContentProvider } from './components/stack/components/BaseContentProvider/BaseContentProvider';

(() => {
  const surveyUrl = window.Jbhifi?.checkoutSurveyUrl;
  const container = document.getElementById('checkout-survey-root');

  if (!surveyUrl || !container) {
    drawDefaultLayout();
    return;
  }

  const root = createRoot(container);
  root.render(
    <BaseContentProvider>
      <DefaultLayout shouldHideCompareBar>
        <CheckoutSurveyPage surveyUrl={surveyUrl} />
      </DefaultLayout>
    </BaseContentProvider>
  );
})();
